import React, { useRef } from 'react'
import { useContext } from 'react'
import { ThemeContext } from 'src/context/ThemeContext'
import {
  BusinessPaywallCloseButton,
  BusinessPaywallCloseButtonContainer,
  BusinessPaywallCloseIcon,
  BusinessPaywallContent,
  BusinessPaywallContentContainer,
  PaywallCheckIcon,
  PaywallFeatureListContainer,
  PaywallFeatureTable,
  PaywallFeatureTableData,
  PaywallFeatureTableRow,
  PaywallGetTrialButtonPrimary,
  PaywallPlanCardContainer,
  PaywallPlanContainer,
  PaywallPlanFeatureListItem,
  PaywallPlanHeading,
  PaywallPlanName,
  PaywallPlanRecommendedText,
  PaywallPlanRecommendedTextPlaceholder,
  PaywallPlanSubtext,
  PaywallPlansContainer,
  PaywallTrialButton,
  PaywallTrialFeatuersContainer,
  PaywallTrialHeading,
  PaywallTrialHeadingHighlight,
  PaywallTrialSubHeading,
  PlanMainDetailsContainer,
  PlanPriceText,
  TestimoinalContainer,
  TestimoinalUser,
  TestimonialDivider,
  TestimonialProfileImage,
  TestimonialQuoteIcon,
  TestimonialText,
  TestimonialsCardsContainer,
  TestimonialsContainer,
  TestimonialsHeading,
} from './styledComponents'
import Check from '@mui/icons-material/Check'
import { putDataWithoutParams } from 'src/consumer/services/featureServices'
import { BusinessProfileContext } from 'src/business/context/BusinessProfileContext'
import { v4 as uuidv4 } from 'uuid'
import { platformWeb } from 'src/consumer/services'
import { displayRazorpayForOneOnOne } from 'src/consumer/components/EventBooking/BookingHelperFunctions'
import { useState } from 'react'
import { useEffect } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { getLanguageCode } from 'src/business/services'
import { makePayment } from 'src/consumer/services/paymentService'
import { currency_list } from 'src/consumer/constants'
import useOnScreen from 'src/business/hooks/useOnScreen'
import { BusinessSubscriptionPlanCard } from './components/BusinessSubscriptionPlanCard'
import FaqSection from 'src/consumer/components/PrewallAndPaywall/FaqSection'

function emptyFunct() {}

export default function PaywallComponent({
  view = 'drawer',
  data,
  togglePaywall,
  testimonialData,
}) {
  const { theme } = useContext(ThemeContext)
  const [paymentDataLoading, setPaymentDataLoading] = useState(false)
  const [stripePromise, setStripePromise] = useState(null)
  const [windowWidth, setWindowWidth] = useState(0)
  const [paymentMethod, setPaymentMethod] = useState('upi')
  const planSectionRef = useRef(null)
  const isVisible = useOnScreen(planSectionRef)
  const isADrawer = view !== 'widget'
  const [minSeats, setMinSeats] = useState(10)

  useEffect(() => {
    loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY).then((result) => {
      setStripePromise(result)
    })
  }, [])
  const updateWindowWidth = () => {
    setWindowWidth(window.innerWidth)
  }
  useEffect(() => {
    window.addEventListener('resize', updateWindowWidth)

    // Clean up the event listener on component unmount
    return () => window.removeEventListener('resize', updateWindowWidth)
  }, [])

  const handlePayments = async (paymentGateway, planId, planSuccessMessage) => {
    setPaymentDataLoading(true)

    setPaymentDataLoading(false)
    makePayment(
      planId,
      paymentMethod,
      paymentGateway,
      'Done',
      isADrawer ? togglePaywall : emptyFunct,
    )
    // if (paymentGateway === 'stripe') {
    //   if (response?.status === 200) {
    //     stripePromise.redirectToCheckout({
    //       sessionId: response?.data?.sessionId,
    //     })
    //   }
    // }
  }

  return (
    <BusinessPaywallContent
      sx={{ margin: `${isADrawer ? 0 : 2}rem 0px`, borderRadius: `${isADrawer ? 0 : 24}px` }}
      themeType={theme}
    >
      <BusinessPaywallCloseButtonContainer>
        {isADrawer && (
          <BusinessPaywallCloseButton onClick={togglePaywall}>
            <BusinessPaywallCloseIcon />
          </BusinessPaywallCloseButton>
        )}
      </BusinessPaywallCloseButtonContainer>
      <BusinessPaywallContentContainer>
        <PaywallTrialHeading themeType={theme}>
          Upgrade to{' '}
          <PaywallTrialHeadingHighlight themeType={theme}>Enterprise!</PaywallTrialHeadingHighlight>
        </PaywallTrialHeading>

        <PaywallTrialSubHeading themeType={theme}>
          Get a dedicated success manager and more!
        </PaywallTrialSubHeading>
        <BusinessSubscriptionPlans
          data={data}
          themeType={theme}
          handlePayments={handlePayments}
          windowWidth={windowWidth}
          sectionRef={planSectionRef}
          seats={minSeats}
          setSeats={setMinSeats}
        />

        {/* <PaywallTrialFeatuersContainer themeType={theme}>
          <FeatureTable />
        </PaywallTrialFeatuersContainer> */}
      </BusinessPaywallContentContainer>

      <BusinessPayTestimonials data={{ testimonials: testimonialData }} themeType={theme} />
      {/* <Fade in={!isVisible}>
        <PaywallTrialButton
          sx={{ position: 'fixed', bottom: '20px' }}
          onClick={() => handleScroll(planSectionRef.current)}
          themeType={theme}
        >
          Get Subscription
        </PaywallTrialButton>
      </Fade> */}
    </BusinessPaywallContent>
  )
}

//

function FeatureTable({ theme }) {
  return (
    <PaywallFeatureTable>
      <PaywallFeatureTableRow header>
        <PaywallFeatureTableData></PaywallFeatureTableData>
        <PaywallFeatureTableData>Free</PaywallFeatureTableData>
        <PaywallFeatureTableData>Unlimited</PaywallFeatureTableData>
      </PaywallFeatureTableRow>
      <PaywallFeatureTableRow>
        <PaywallFeatureTableData>Feature Title</PaywallFeatureTableData>
        <PaywallFeatureTableData>
          <PaywallCheckIcon />
        </PaywallFeatureTableData>
        <PaywallFeatureTableData>
          <PaywallCheckIcon />
        </PaywallFeatureTableData>
      </PaywallFeatureTableRow>
      <PaywallFeatureTableRow>
        <PaywallFeatureTableData>Feature Title</PaywallFeatureTableData>
        <PaywallFeatureTableData>
          <PaywallCheckIcon />
        </PaywallFeatureTableData>
        <PaywallFeatureTableData>
          <PaywallCheckIcon />
        </PaywallFeatureTableData>
      </PaywallFeatureTableRow>
    </PaywallFeatureTable>
  )
}

//

function BusinessSubscriptionPlans({
  data,
  themeType,
  handlePayments,
  windowWidth,
  sectionRef,
  seats,
  setSeats,
}) {
  return (
    <PaywallPlanContainer>
      <PaywallPlansContainer ref={sectionRef}>
        {data &&
          data?.map((plan) => (
            <BusinessSubscriptionPlanCard
              themeType={themeType}
              planData={plan}
              key={plan?.id}
              handlePayments={handlePayments}
              windowWidth={windowWidth}
              seats={seats}
              setSeats={setSeats}
            />
          ))}
      </PaywallPlansContainer>
    </PaywallPlanContainer>
  )
}
//

function BusinessPayTestimonials({ data, themeType }) {
  return (
    <TestimonialsContainer>
      <TestimonialsHeading>What People Say</TestimonialsHeading>
      <TestimonialsCardsContainer>
        {data?.testimonials?.map((testimonial) => (
          <BusinessPaywallTestimonial key={testimonial.id} data={testimonial} />
        ))}
      </TestimonialsCardsContainer>
    </TestimonialsContainer>
  )
}

function BusinessPaywallTestimonial({ data, themeType, sectionRef }) {
  return (
    <TestimoinalContainer sectionRef type={data?.type}>
      <TestimonialProfileImage type={data?.type} src={data?.profileIcon} alt={data?.name} />
      <TestimonialText type={data?.type}>
        <TestimonialQuoteIcon type={data?.type} />
        {data?.comment}
      </TestimonialText>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <TestimonialDivider type={data?.type} />
        <TestimoinalUser type={data?.type}>{data?.name}</TestimoinalUser>
      </div>
    </TestimoinalContainer>
  )
}

//
